module.exports = __webpack_public_path__ + "static/media/433563387_717124976975210_4595315021458415536_n.f31e954d.jpg";